import { ComponentPropsWithoutRef, ReactElement, forwardRef } from 'react';

import classNames from 'classnames';

import { flexClassNames } from '@spotify-internal/encore-web';

import { useContentNavigationContext } from '../context';
import { MenuItem } from './MenuItem';

import styles from '../ContentNavigation.module.css';

export type ContentNavigationMenuProps = ComponentPropsWithoutRef<'nav'>;

export const Menu = forwardRef<HTMLElement, ContentNavigationMenuProps>(
  (
    {
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      children,
      className,
      ...props
    },
    ref,
  ): ReactElement | null => {
    const { sections } = useContentNavigationContext();
    if (children === undefined && sections.length < 2) return null;

    const itemsFromSections = sections.map(({ id, label }) => (
      <MenuItem key={id} href={`#${encodeURIComponent(id)}`} data-track-source-anchor="e245031d22;menu-item;low">
        {label}
      </MenuItem>
    ));

    return (
      <nav
        {...props}
        ref={ref}
        aria-label={ariaLabelledBy ? undefined : (ariaLabel ?? 'On this page')}
        aria-labelledby={ariaLabelledBy}
        className={classNames(
          flexClassNames({ direction: 'column', gap: 'tighter-4' }),
          styles.menu,
          className,
        )}
      >
        {children ?? itemsFromSections}
      </nav>
    );
  },
);

Menu.displayName = 'Page.ContentNavigation.Menu';
